import { currentYear } from "@/types/current-year";
import {
	FaFacebook,
	FaInstagram,
	FaRegClock,
	FaWhatsapp,
} from "react-icons/fa";
import type { Data } from "../types/data";
import ButtonWhatsApp from "./button-whatsapp";
import logoMarca from "/public/logoMarca/poweredBy.avif";

const socialIcons = {
	WhatsApp: FaWhatsapp,
	Instagram: FaInstagram,
	Facebook: FaFacebook,
};

const date = currentYear;

interface FooterProps {
	data: Data;
}

export default function Footer({ data }: FooterProps) {
	const activeSocialLinks = data.cliente["redes-sociais"].filter(
		(social) => social.ativa,
	);

	return (
		<footer className="relative overflow-hidden bg-brand-secondary-900 text-zinc-100">
			<div className="h-1 w-full bg-brand-secondary-500" />

			<div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
				<div className="grid gap-10 md:grid-cols-2 xl:grid-cols-4">
					<div className="xl:col-span-2">
						<h2 className="text-2xl font-bold text-white">
							{data.cliente.nome}
						</h2>
						<p className="mt-3 max-w-lg text-sm leading-relaxed text-zinc-300">
							{data["area-inicial"].texto}
						</p>
					</div>

					<div>
						<h3 className="text-sm font-semibold uppercase tracking-wide text-zinc-400">
							Redes sociais
						</h3>
						<ul className="mt-4 flex items-center gap-3">
							{activeSocialLinks.map((social) => {
								const Icon =
									socialIcons[social.nome as keyof typeof socialIcons];
								if (!Icon) return null;

								return (
									<li key={social.nome}>
										<a
											href={social.url}
											target="_blank"
											rel="noopener noreferrer"
											className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-zinc-700 text-zinc-300 transition-colors hover:border-zinc-500 hover:text-white"
											aria-label={social.nome}
										>
											<Icon />
										</a>
									</li>
								);
							})}
						</ul>
					</div>

					<div>
						<h3 className="text-sm font-semibold uppercase tracking-wide text-zinc-400">
							Horário de atendimento
						</h3>
						<ul className="mt-4 space-y-2 text-sm text-zinc-300">
							{data.cliente["horario-comercial"].map((item, index) => (
								<li
									key={`${item.dia}-${index}`}
									className="flex items-start gap-2"
								>
									<FaRegClock className="mt-0.5 shrink-0 text-zinc-500" />
									<span>
										{item.dia} {item.horario}
									</span>
								</li>
							))}
						</ul>
					</div>
				</div>

				<div className="mt-10 border-t border-zinc-800 pt-8">
					<div className="flex flex-col items-center justify-center gap-4 text-center">
						<img
							src={logoMarca}
							alt="Powered by BemSoft"
							className="h-10 w-auto md:h-12"
							width="150"
							height="48"
						/>
						<p className="text-sm text-zinc-400">
							Copyright (c) {date} BemSoft.
						</p>
					</div>
				</div>
			</div>

			<ButtonWhatsApp data={data} />
		</footer>
	);
}
